import { render, staticRenderFns } from "./addOrEditMessage.vue?vue&type=template&id=eef7b052&"
import script from "./addOrEditMessage.vue?vue&type=script&lang=js&"
export * from "./addOrEditMessage.vue?vue&type=script&lang=js&"
import style0 from "./addOrEditMessage.vue?vue&type=style&index=0&id=eef7b052&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports